(function () {
  var ROOT_SELECTOR = '[data-footer-newsletter]';

  function getMessage(root, name) {
    return root && root.dataset ? root.dataset[name] || '' : '';
  }

  function showToast(message, type) {
    if (!message || typeof window.showToast !== 'function') return;
    window.showToast(message, type);
  }

  function getSpinnerMarkup() {
    return [
      '<svg class="prea-newsletter-spinner" viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="4" stroke-dasharray="32" stroke-dashoffset="0"></circle>',
      '</svg>'
    ].join('');
  }

  function getResponseMessage(doc, id) {
    var message = doc.getElementById(id);
    return message ? message.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function initNewsletter(root) {
    if (!root || root.dataset.footerNewsletterInitialized === 'true') return;

    var form = root.querySelector('form');
    if (!form) return;

    var button = form.querySelector('button[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');
    if (!button || !emailInput) return;

    root.dataset.footerNewsletterInitialized = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var originalText = button.innerHTML;
      button.innerHTML = getSpinnerMarkup();
      button.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'text/html'
        }
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var successMessage = getResponseMessage(doc, 'ContactFooter-success');
          var errorMessage = getResponseMessage(doc, 'ContactFooter-error');

          if (successMessage) {
            showToast(getMessage(root, 'newsletterSuccessMessage') || successMessage, 'success');
            form.reset();
          } else if (errorMessage) {
            showToast(errorMessage || getMessage(root, 'newsletterErrorMessage'), 'error');
          } else {
            showToast(getMessage(root, 'newsletterSuccessMessage'), 'success');
            form.reset();
          }
        })
        .catch(function () {
          showToast(getMessage(root, 'newsletterRequestErrorMessage'), 'error');
        })
        .finally(function () {
          button.innerHTML = originalText;
          button.disabled = false;
        });
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
